import { createContext } from 'react';

const DeliveryKeyContext = createContext();

export default DeliveryKeyContext;
